
import { Vue, Component } from 'vue-property-decorator'

const config = {
  name: 'c-button-icon'
}

@Component(config)
export default class CButton extends Vue {}
